/* src/js/searchBar.js */

jQuery(document).ready(function ($) {


    if ($(".searchBar").length) {

        $('<i class="js-searchTrigger material-icons">search</i>').prependTo(".navMain__trigger");


        $('body').addClass('searchBar-present').on('click', '.js-searchTrigger', function () {
            $('body').toggleClass('searchBar-open');
        });


    }

});
